import { render } from "./DeleteRoleResultModal.vue?vue&type=template&id=d851129c&scoped=true"
import script from "./DeleteRoleResultModal.vue?vue&type=script&lang=js"
export * from "./DeleteRoleResultModal.vue?vue&type=script&lang=js"

import "./DeleteRoleResultModal.vue?vue&type=style&index=0&id=d851129c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d851129c"]])

export default __exports__